import assign = require('object-assign');
import { Promise } from 'es6-promise';

import { Customer } from '../constants';
import { defaultFactory as request } from '../api/RequestFactory';
import FSA from './FSA';

interface ICustomerState {
    cId?: string,
    id?: string,
    name?: string,
    companyName?: string,
}

function formatCustomer(customer: ICustomerState): ICustomerState {
    const id = customer.cId || customer.id;
    const name = customer.name || customer.companyName;

    customer.cId = customer.id = id;
    customer.name = customer.companyName = name;

    return customer;
}

function fetchCustomer(requesterId: string, query): Promise<ICustomerState> {
    return request.get(`customer/${query.cId}`, query);
}

function fetchCustomers(requesterId: string, query): Promise<ICustomerState[]> {
    return request.post(`me/query`, {
        agent: false,
        container: false,
        customer: true,
        query: {},
    });
}

export function getCustomer(requesterId: string, cId: string): any {
    return dispatch => {
        dispatch(new FSA(Customer.FETCH_CUSTOMER_REQUEST).addMeta({ requesterId, cId }).data);

        return fetchCustomer(requesterId, { cId }).then((nodes) => {
            return dispatch(new FSA(Customer.FETCH_CUSTOMER_SUCCESS).addPayload(nodes).addMeta({ requesterId, cId }).data);
        }, err => {
            dispatch(new FSA(Customer.FETCH_CUSTOMER_FAILURE).addError(err).addMeta({ requesterId, cId }).data);
            throw err;
        });
    }
}

export function listCustomers(requesterId: string): any {
    return dispatch => {
        dispatch(new FSA(Customer.FETCH_CUSTOMERS_REQUEST).addMeta({ requesterId }).data);

        return fetchCustomers(requesterId, {}).then(nodes => {
            if(nodes) {
                nodes = nodes.map(formatCustomer);
            }

            return dispatch(new FSA(Customer.FETCH_CUSTOMERS_SUCCESS).addPayload(nodes).addMeta({ requesterId }).data);
        }, err => {
            dispatch(new FSA(Customer.FETCH_CUSTOMERS_FAILURE).addError(err).addMeta({ requesterId }).data);
            throw err;
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/Customer.ts